import { Role } from '@caresend/types';
import { isEncrypted, isNonEmptyString } from './basicGuards.js';
import { getNonEmptyStringErrors } from './helpers.js';
import { getKeyValidationErrors } from './validation.js';

const getEncryptedSubmitterIDErrors = (submitterID, feedback) => {
  if (feedback.submitterRole === Role.PATIENT) {
    if (isEncrypted(submitterID)) return null;
    return 'Expected encrypted submittedID to match submitter role patient';
  }

  if (isEncrypted(submitterID)) {
    return 'Expected non-encrypted submitterID to match submitter role ' + `${feedback.submitterRole}`;
  }

  if (!isNonEmptyString(submitterID)) return 'Expected non-empty submitterID.';
  return null;
};

const sharedFeedbackValidationKeys = {
  channel: true,
  creationTimestamp: true,
  feedbackCategory: true,
  freeText: getNonEmptyStringErrors,
  id: getNonEmptyStringErrors,
  feedbackObjectID: getNonEmptyStringErrors,
  feedbackObjectType: true,
  originType: true,
  originID: getNonEmptyStringErrors,
  rating: true,
  subjectID: getNonEmptyStringErrors,
  subjectType: true,
  submitterRole: true
};
const feedbackValidationKeys = Object.assign(Object.assign({}, sharedFeedbackValidationKeys), {
  submitterID: getNonEmptyStringErrors
});
const encryptedFeedbackValidationKeys = Object.assign(Object.assign({}, sharedFeedbackValidationKeys), {
  submitterID: getEncryptedSubmitterIDErrors
});
/**
 * Validate Partial<Feedback>
 * We allow unvalidated feedback to be submitted if the user rates 4 or 5 stars.
 * This feature can be turned on by allowHighRatingToSkipValidation, only used on the pro app for now.
 */

const isFeedbackValid = (feedback, allowHighRatingToSkipValidation) => allowHighRatingToSkipValidation && (feedback.rating === 4 || feedback.rating === 5) || !getKeyValidationErrors(feedback, feedbackValidationKeys);
/**
 * Get validated feedback object, or throw an error with details on failure(s).
 */

const getValidatedFeedback = (feedback, allowHighRatingToSkipValidation) => {
  if (!isFeedbackValid(feedback, allowHighRatingToSkipValidation)) {
    throw Error(`Feedback does not pass validation:
      ${getKeyValidationErrors(feedback, feedbackValidationKeys)}`);
  }

  return feedback;
};
/**
 * Validate Partial<EncryptedFeedback>
 */

const isEncryptedFeedbackValid = feedback => !getKeyValidationErrors(feedback, encryptedFeedbackValidationKeys);
/**
 * Get validated feedback object, or throw an error with details on failure(s).
 */

const getValidatedEncryptedFeedback = feedback => {
  if (!isEncryptedFeedbackValid(feedback)) {
    throw Error(`Feedback does not pass validation:
      ${getKeyValidationErrors(feedback, encryptedFeedbackValidationKeys)}`);
  }

  return feedback;
};
const isFeedback = object => object.feedbackObjectID !== undefined;

export { getValidatedEncryptedFeedback, getValidatedFeedback, isEncryptedFeedbackValid, isFeedback, isFeedbackValid };
